import type { FlatField } from '../types';
import { LeafInput } from './LeafInput';

export function LeafValueEditor(props: { field: FlatField; value: unknown; onChange: (value: unknown) => void }) {
  const { field, value, onChange } = props;
  const node = field.node;

  if (node.type === 'object') {
    return (
      <div className="text-muted-foreground rounded-xl border p-4 text-sm">
        Objects don’t take a direct value. Select a child field and set values there.
      </div>
    );
  }

  // ✅ shared renderer
  return <LeafInput node={node} label="Value" value={value} onChange={onChange} />;
}
